<template>
  <div class="wrapper">
    <div class="custom-training" :style="bgImg">
      <div class="title">{{title}}</div>
      <div class="detail">{{detail}}</div>
      <div class="training-nav-btn">{{title}}のページへ</div>
      <div class="bg-layer"></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CustomTraining",
  props: {
    title: {
      type: String,
      default: "名称未設定"
    },
    detail: {
      type: String,
      default: "未設定"
    },
    bgUrl: {
      type: String,
      default: ""
    }
  },
  computed: {
    bgImg() {
      return `background: url('${this.bgUrl}'); background-size: cover`;
    }
  }
};
</script>

<style lang="scss" scoped>
.wrapper {
}

.custom-training {
  position: relative;
  overflow: hidden;
  width: 530px;
  height: 190px;
  border: 1px solid #ddd;
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  &:hover {
    .training-nav-btn {
      transform: translateX(0);
      opacity: 1;
    }
    .bg-layer {
      background: linear-gradient(
        45deg,
        rgba(255, 255, 255, 0.4),
        rgba(255, 255, 255, 0.9)
      );
    }
  }
}

.bg-layer {
  width: 100%;
  height: 100%;
  background: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.6),
    rgba(255, 255, 255, 1)
  );
  position: absolute;
  top: 0;
  left: 0;
}

.training-nav-btn {
  opacity: 0;
  transition: all 0.3s ease;
  transform: translateX(130px);
  font-size: 0.8rem;
  cursor: pointer;
  position: absolute;
  background-color: #222;
  bottom: 10px;
  right: 0;
  border: 0;
  color: #fff;
  padding: 8px 8px 8px 13px;
  margin: auto;
  border-radius: 20px 0 0 20px;
  font-weight: bold;
  z-index: 100;
}

.title,
.detail {
  z-index: 120;
  margin-left: 15px;
}
.title {
  color: #222;
  font-weight: bold;
  font-size: 1.4rem;
}
.detail {
  color: #555;
}
</style>